import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { Chart, useChart } from "@chakra-ui/charts";
import {
  CartesianGrid,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { ClassPopulation } from "../../../services/Dtos";
import { getShortName } from "../../../services/Utils";
import useThemeColors from "../../../hooks/useThemeColors";

interface ClassPopulationChartProps {
  classData: ClassPopulation[] | null;
}

const ClassPopulationChart: React.FC<ClassPopulationChartProps> = ({
  classData,
}) => {
  const colors = useThemeColors();

  const chart = useChart({
    data: classData || [],
    series: [{ name: "className", color: "teal.solid" }],
  });

  // Custom Tooltip Component
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <Box
          bg={colors.background.tertiary}
        
          p={4}
          borderRadius="md"
          boxShadow="md"
          borderWidth={1}
          fontSize={"sm"}
        >
          <Text fontWeight="bold">{label}</Text>
          <Text>{`Population: ${payload[0].value}`}</Text>
        </Box>
      );
    }

    return null;
  };

  return (
    <Chart.Root  pb={5} chart={chart}>
      <BarChart
        data={chart.data}
        margin={{ top: 10, right: 0, left: -30, bottom: -20 }}
      >
        {/* Define gradient */}
        <defs>
          <linearGradient id="colorPopulation" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#00EFB5" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#00A3FF" stopOpacity={0.8} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke={chart.color("border.muted")} vertical={false} />
        <XAxis
          tickLine={false}
          axisLine={false}
          dataKey="className"
          fontSize={"12px"}
          fontWeight={"bold"}
          interval={0}
          tickFormatter={(value) => getShortName(value)}
        />
        <YAxis
          fontSize={"12px"}
          domain={[0, "dataMax"]}
          fontWeight={"bold"}
          tickFormatter={(value) => value.toFixed(1)}
        />
        <Tooltip
          cursor={{ fill: chart.color("bg.muted") }}
          content={<CustomTooltip />}
          animationDuration={100}
        />

        <Bar
          dataKey="population"
          fill="url(#colorPopulation)"
          barSize={20}
          radius={[5, 5, 0, 0]}
        />
      </BarChart>
    </Chart.Root>
  );
};

export default ClassPopulationChart;
